import javaService from "../../utils/request"
function handel(data) {
  var params = new URLSearchParams()
  for (const key in data) {
    params.append(key, data[key])
  }
  return params
}

export function saveAccessory(data){
  return javaService({
    url: '/hkAccessory/saveAccessory',
    method: 'post',
    data: handel(data)
  })
}

export function getByCondition(){
  return javaService({
      url: '/hkAccessoryClassify/getByCondition',
      method: 'GET'
  })
}

export function hkAccessory(data){
  return javaService({
      url: '/hkAccessory/getByCondition',
      method: 'GET',
      params: data
  })
}

export function odelete(data){
  return javaService({
    url: '/hkAccessory/delete',
    method: 'post',
    data: handel(data)
  })
}
